"use client";

import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";
import { GetLomdaV2ResponseType } from "../../hooks/useGetLomdaV2";
import { useState } from "react";
import { client } from "@/lib/hono";
import toast from "@/lib/toast";
import { useQueryClient } from "@tanstack/react-query";
import { LoaderCircle } from "lucide-react";
import { t } from "@/lib/localization";

export default function DuplicateLomdaV2Button({
    lomda,
}: {
    lomda: GetLomdaV2ResponseType["data"];
}) {
    const [loading, setLoading] = useState(false);
    const queryClient = useQueryClient();

    const handleDuplicate = async () => {
        setLoading(true);

        try {
            const res = await client.api.storage["lomda-v2"].duplicate.$post({
                json: {
                    lomdaIdToCopy: lomda.id,
                    newName: t("lomda-sheet.duplicate.default-name", undefined, {
                        name: lomda.name ?? "",
                    }),
                },
            });

            if (!res.ok) {
                const errorData = await res.json();
                console.error("Error duplicating lomdaV2:", errorData);
                toast.error(t("toast.error.duplicate-lomda"), {
                    keyName: "toast.error.duplicate-lomda",
                });
                return;
            }

            const data = await res.json();
            console.log("LomdaV2 duplicated successfully:", data);

            toast.success(t("toast.success.duplicate-lomda"), {
                keyName: "toast.success.duplicate-lomda",
            });

            queryClient.invalidateQueries({ queryKey: ["get-storage-files"] });
            queryClient.invalidateQueries({
                queryKey: ["get-storage-folders"],
            });
        } catch (error) {
            console.error("Error duplicating lomdaV2:", error);
            toast.error(t("toast.error.default"), {
                keyName: "toast.error.default",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            onClick={handleDuplicate}
            disabled={loading}
            variant="secondary"
            size="sm"
        >
            {loading ? (
                <LoaderCircle className="size-3.5 me-2 animate-spin" />
            ) : (
                <Copy className="size-3.5 me-2" />
            )}
            {t("lomda-sheet.header.duplicate-btn", undefined, undefined)}
        </Button>
    );
}
